import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotRecommend from './components/HotRecommend';
import RankingList from './components/RankingList';
import LatestUpdate from './components/LatestUpdate';
import SEO from '@/components/base/SEO';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫画网',
  url: 'https://hanmanhua.com',
  description: '漫画免费韩漫-最新高清免费韩国漫画大全_热门韩漫在线阅读-韩漫画网',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://hanmanhua.com/category/all?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: '韩漫画网',
    url: 'https://hanmanhua.com',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫画网',
  url: 'https://hanmanhua.com',
  description: '提供漫画免费韩漫服务，最新高清免费韩国漫画大全与热门韩漫在线阅读平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@hanmanhua.com',
    contactType: 'customer service',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: '韩漫画网上的韩漫是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，韩漫画网提供漫画免费韩漫服务，所有作品均支持在线免费阅读，无需付费即可畅享最新高清免费韩国漫画大全。' } },
    { '@type': 'Question', name: '网站多久更新一次漫画？', acceptedAnswer: { '@type': 'Answer', text: '我们每日同步更新热门韩漫最新章节，确保您能第一时间阅读到最新的漫画内容，追更无忧。' } },
    { '@type': 'Question', name: '支持手机在线阅读吗？', acceptedAnswer: { '@type': 'Answer', text: '韩漫画网采用响应式设计，完美适配手机、平板和电脑，随时随地享受高清韩漫在线阅读体验。' } },
    { '@type': 'Question', name: '如何找到我喜欢的韩漫类型？', acceptedAnswer: { '@type': 'Answer', text: '点击首页分类导航或进入分类页面，即可按恋爱、奇幻、动作、悬疑等类型浏览免费韩国漫画大全，轻松找到您的喜好。' } },
    { '@type': 'Question', name: '韩漫画网的漫画来源是什么？', acceptedAnswer: { '@type': 'Answer', text: '我们与多家韩国漫画平台合作，所有漫画均获得正版授权，确保读者享受到高质量的漫画免费韩漫内容。' } },
  ],
};

export default function Home() {
  return (
    <main>
      <SEO
        title="漫画免费韩漫-最新高清免费韩国漫画大全_热门韩漫在线阅读-韩漫画网"
        description="韩漫画网提供漫画免费韩漫服务，最新高清免费韩国漫画大全与热门作品支持在线阅读，满足您的追更需求。涵盖恋爱、奇幻、动作、悬疑等多种类型韩漫。"
        keywords="漫画免费韩漫,最新高清,免费韩国漫画大全,热门韩漫,在线阅读,韩漫画网"
        schemaJson={{
          ...homeSchema,
          ...orgSchema,
          ...faqSchema,
        }}
      />
      <HeroSection />
      <CategorySection />
      <HotRecommend />
      <RankingList />
      <LatestUpdate />

      {/* FAQ Section for structured data */}
      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 text-center mb-6">常见问题</h2>
        <div className="max-w-3xl mx-auto grid gap-3">
          {[
            { q: '韩漫画网上的韩漫是免费的吗？', a: '是的，韩漫画网提供漫画免费韩漫服务，所有作品均支持在线免费阅读，无需付费即可畅享最新高清免费韩国漫画大全。' },
            { q: '网站多久更新一次漫画？', a: '我们每日同步更新热门韩漫最新章节，确保您能第一时间阅读到最新的漫画内容，追更无忧。' },
            { q: '支持手机在线阅读吗？', a: '韩漫画网采用响应式设计，完美适配手机、平板和电脑，随时随地享受高清韩漫在线阅读体验。' },
            { q: '如何找到我喜欢的韩漫类型？', a: '点击首页分类导航或进入分类页面，即可按恋爱、奇幻、动作、悬疑等类型浏览免费韩国漫画大全，轻松找到您的喜好。' },
            { q: '韩漫画网的漫画来源是什么？', a: '我们与多家韩国漫画平台合作，所有漫画均获得正版授权，确保读者享受到高质量的漫画免费韩漫内容。' },
          ].map((faq, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between p-4 md:p-5 font-medium text-sm text-foreground-900 group-open:text-primary-600 list-none">
                <span>{faq.q}</span>
                <i className="ri-arrow-down-s-line text-lg transition-transform group-open:rotate-180"></i>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative w-full py-14 md:py-20 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20background%20with%20warm%20coral%20and%20amber%20flowing%20waves%2C%20gentle%20curves%20and%20organic%20shapes%2C%20dreamy%20and%20peaceful%20atmosphere%2C%20minimal%20composition%2C%20no%20text%2C%20no%20sharp%20lines&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-500/85"></div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white">即刻开启您的韩漫阅读之旅</h2>
          <p className="mt-3 text-sm text-white/80 max-w-xl mx-auto">
            加入500万+读者，畅享最新高清免费韩国漫画大全，热门韩漫在线阅读尽在韩漫画网
          </p>
          <a
            href="/category/all"
            className="inline-block mt-6 px-8 py-3 bg-white text-primary-600 font-medium rounded-full text-sm hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>
    </main>
  );
}